<template>
  <div class="tr cart_item" :id="showIdTwo">
    <div class="td itemphoto">
      <div class="bx_ordercart_photo_container">
        <a :href="catalogLink">
          <div class="bx_ordercart_photo transpanent" v-if="availableQuantity===0">
            <img :src="previewImage" :alt="name" :title="name" :srcset="`${previewImage}, ${previewImage2x} 2x`">
          </div>
          <div class="bx_ordercart_photo" v-else>
            <img :src="previewImage" :alt="name" :title="name" :srcset="`${previewImage}, ${previewImage2x} 2x`">
          </div>
        </a>
      </div>
    </div>
    <div class="td item">
      <div class="cart_desc_product">
        <h2 class="bx_ordercart_itemtitle">
          <a :href="catalogLink">
            {{ name }}
          </a>
        </h2>
      </div>
      <div class="bx_ordercart_itemart">
        <template v-for="(value, name) in basketProperties">
          {{ name }}: <span>{{ value }}</span><br>
        </template>
      </div>
    </div>
    <div class="td custom forsale">
      <div class="cart_discount" v-if="showDiscountValue">
        <span class="cart_discount__value">{{ discountValueFormatted }}</span>
        <span class="cart_discount__price">
          {{ oldPrice - price }}
          <ruble><span class="text">СЂСѓР±.</span></ruble>
        </span>
      </div>
    </div>
    <div class="td price">
      <del class="old_cart_price" v-if="oldPriceFormatted" v-html="oldPriceFormatted"></del>
      <div class="new_cart_price" v-if="availableQuantity>0" v-html="priceFormatted"></div>

    </div>
    <div class="td custom">
      <div class="centered">
        <table class="counter" v-if="availableQuantity>0">
          <tbody>
          <tr>
            <td class="cell_qty_inner">
              <div class="card_form_row">
                <div class="count_card_wrap">
                  <div class="count_card_plus" @click="addOne" />
                  <div class="count_card_minus" @click="removeOne" />
                  <input
                      type="text"
                      class="count_card"
                      min="0"
                      :max="availableQuantity"
                      :value="quantity"
                      @input="handleInputChange"
                      readonly
                      style="background-color: #fefefe"
                  >
                  <div class="mytooltip" ref="limit-hint">
                    {{ reachedLimitMessage.replace('#QUANTITY_LIMIT#', availableQuantity) }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="bx_ordercart_itemart empty-basket" v-if="availableQuantity===0" >{{ notInStock }} </div>
        <div class="like_good_ico empty-basket" v-if="availableQuantity===0">
          <div class="like_good_ico_animate">
            <div class="wishlist_container">
              <span class="pixel-add-wish" :data-id='showId'></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="td control">

      <a
          class="close-button"
          :href="deleteLink"
          @click.prevent="deleteItem">
        <span>{{ closeIcon }}</span>
      </a>
      <br>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
    productId: String,
    name: String,
    catalogLink: String,
    quantity: Number,
    availableQuantity: Number,
    priceFormatted: String,
    oldPriceFormatted: String,
    discountValueFormatted: String,
    basketProperties: {},
    previewImage: String,
    previewImage2x: String,
    price: Number,
    oldPrice: Number
  },
  methods: {
    deleteItem() {
      this.updateQuantity(0);
    },
    updateQuantity(newValue) {
      if (newValue > this.availableQuantity) {
        this.showLimitHint();

        if (this.quantity === this.availableQuantity) {
          return;
        }

        if(this.quantity < this.availableQuantity && this.availableQuantity <= 10) {
          BX.onCustomEvent('OnBasketAdd', {offerId: this.originProductId.toString(), quantity: this.availableQuantity});
        }

        this.$emit('input', this.availableQuantity);
        return;
      }

      if(this.quantity < newValue && newValue <= 10) {
        BX.onCustomEvent('OnBasketAdd', {offerId: this.originProductId.toString(), quantity: newValue});
      } else if(this.quantity > newValue) {
        BX.onCustomEvent('OnBasketRemove', {
          offerId: this.originProductId.toString(),
          quantity: this.quantity - newValue,
          sizeId: this.sizeId.toString()
        });
      }

      this.$emit('input', newValue);
    },

    handleInputChange(event) {
      if (event.target.value !== '') {
        this.updateQuantity(event.target.value);
      }
    },

    addOne() {
      this.updateQuantity(this.quantity + 1);
    },
    removeOne() {
      this.updateQuantity(this.quantity - 1);
    },

    showLimitHint() {
      const hint = $(this.$refs['limit-hint']);
      hint.slideUp(100);
      setTimeout(() => hint.slideDown(200),5000);
    },
  },
  computed: {
    notInStock(){
      return BX.message('KZ_BASKET_PRODUCT_OUT_STOCK');
    },
    closeIcon() {
      return BX.message('KZ_BASKET_DELETE_ITEM_ICON');
    },
    deleteLink() {
      return `/personal/cart/?basketAction=delete&amp;id=${this.id}`;
    },
    showId(){
       checkProductsInWishlist(this.$parent.result.GRID.ROWS[this.id].ORIGIN_PRODUCT_ID);
      return this.$parent.result.GRID.ROWS[this.id].ORIGIN_PRODUCT_ID;
    },
    showIdTwo(){
      return 'product-id-'+this.$parent.result.GRID.ROWS[this.id].ORIGIN_PRODUCT_ID;
    },
    reachedLimitMessage() {
      return BX.message('KZ_BASKET_AVAILABLE_QUANTITY_REACHED');
    },
    showDiscountValue() {
      return this.discountValueFormatted !== '0%';
    },
    originProductId() {
      return this.$parent.result.GRID.ROWS[this.id].ORIGIN_PRODUCT_ID;
    },
    sizeId: function sizeId() {
      return this.$parent.result.GRID.ROWS[this.id].PRODUCT_ID;
    }
  }
}
</script>
